export const LANGUAGE_OPTIONS = [
  { id: 'en', key: 'english' },
  { id: 'es', key: 'spanish' },
  { id: 'pt', key: 'portuguese' },
];

export const LANGUAGE_OPTIONS_DATA = LANGUAGE_OPTIONS.map(option => ({
  label: option.key.charAt(0).toUpperCase() + option.key.slice(1),
  id: option.id,
}));
